import { IResult } from '../../../../../../httpClient/serverApi/types/IResponse';
import { IAnalyticsExtSiteSettings } from '../../../../../../settings/types/ISiteSettingsForSiteAdmin';
import { TagRequest } from '../../../TagRequest';

export type IGetAnalyticsExtSiteSettingsResult = IResult & IAnalyticsExtSiteSettings;

export class GetAnalyticsExtSiteSettingsRequest extends TagRequest<{}, IGetAnalyticsExtSiteSettingsResult> {
  constructor() {
    super('analyticsextensions', 'getAnalyticsExtensionsSiteSettings', {});
  }
}
